import * as types from '../types/marketing'
import marketing from 'api/marketing'
import _debounce from 'lodash.debounce'
import TimeAndDate from 'utils/TimeAndDate'

export const setExcelData = (excelData) => ({ type: types.SET_EXCEL_DATA, excelData })
export const setCampaignData = (campaign) => ({ type: types.SET_CAMPAIGN_DATA, campaign })
export const reinitializeCampaignData = () => ({ type: types.REINITIALIZE_CAMPAIGN_DATA })

export const updateExcelUsers = (excelUsers) => ({ type: types.UPDATE_EXCEL_USERS, excelUsers })
export const updateOverwriteName = (canOverwriteName) => ({ type: types.UPDATE_OVERWRITE_NAME, canOverwriteName })
export const updateFilters = (filters) => ({ type: types.UPDATE_FILTERS, filters })

export const updateAdvancedFilters = (advancedFilters) => ({
  type: types.UPDATE_ADVANCED_FILTERS,
  advancedFilters,
})

export const getAllTemplatesRequestAct = () => ({ type: types.MARKETING_GET_ALL_TEMPLATES_REQUEST })
export const getAllTemplatesSuccessAct = (data) => ({
  type: types.MARKETING_GET_ALL_TEMPLATES_SUCCESS,
  data,
})

const createTemplateRequestAct = () => ({ type: types.MARKETING_CREATE_TEMPLATE_REQUEST })
const createTemplateSuccessAct = (data) => ({
  type: types.MARKETING_CREATE_TEMPLATE_SUCCESS,
  data,
})

const updateTemplateRequestAct = () => ({ type: types.MARKETING_UPDATE_TEMPLATE_REQUEST })
const updateTemplateSuccessAct = (data) => ({
  type: types.MARKETING_UPDATE_TEMPLATE_SUCCESS,
  data,
})

const publishTemplateRequestAct = () => ({ type: types.MARKETING_PUBLISH_TEMPLATE_REQUEST })
const publishTemplateSuccessAct = (data) => ({
  type: types.MARKETING_PUBLISH_TEMPLATE_SUCCESS,
  data,
})

const deleteTemplateRequestAct = () => ({ type: types.MARKETING_DELETE_TEMPLATE_REQUEST })
const deleteTemplateSuccessAct = (data) => ({
  type: types.MARKETING_DELETE_TEMPLATE_SUCCESS,
  data,
})

const getTemplateVariablesRequestAct = () => ({
  type: types.MARKETING_GET_TEMPLATE_VARIABLES_REQUEST,
})
const getTemplateVariablesSuccessAct = (data) => ({
  type: types.MARKETING_GET_TEMPLATE_VARIABLES_SUCCESS,
  data,
})

const getCampaignsRequest = (data) => ({
  type: types.MARKETING_GET_CAMPAIGNS,
  data,
})

const getCampaignRequest = (data) => ({
  type: types.MARKETING_GET_CAMPAIGN,
  data,
})

export const updateChannels = (channels) => ({ type: types.UPDATE_CHANNEL, channels })

const callBounce = _debounce((dispatch) => { dispatch(getCampaigns()) }, 250)

// const campaignsUpdateFilters = (data) => ({
//   type: types.MARKETING_CAMPAIGNS_UPDATE_FILTERS,
//   data
// })

export const emptyCampaign = {
  createdBy: '',
  company: '',
  id: null,
  name: '',
  startDate: '',
  endDate: '',
  duration: 0,
  durationLabel: '',
  cost: 0,
  costCurrency: 'EUR',
  externalId: '',
  occasionName: '',
  occasionId: '',
  filterTickets: {},
  excelUsers: [],
  channels: [],
  usersByChannel: [],
  totalUsers: 0,
  launchDate: '',
  templates: [],
  selectedUsers: [],
  facebookCampaign: {},
  canOverwriteName: false
}

export const upsertCampaign = (action) => (dispatch, oldState) => {
  const {
    marketing: { campaign },
  } = oldState()

  if (campaign._id) {
    const filterKeys = Object.keys(campaign.filterTickets)
    if (filterKeys.length) {
      filterKeys.forEach((key) => {
        campaign.filterTickets[key] = campaign.filterTickets[key].map((elem) => elem.value || elem)
      })
    }

    return marketing
      .updateCampaign({ id: campaign._id, data: campaign })
      .then(({ data, status }) => {
        if (status === 200) {
          if (action === 'saveAndClose') {
            dispatch(setCampaignData(emptyCampaign))
          } else {
            dispatch(setCampaignData(data.result))
          }
        }
      })
      .catch(({ response = {}, message }) => {
        const { data } = response
        console.error('Update campaign error', data || message)
        throw data || message
      })
  } else {
    return marketing
      .postCampaign({ data: campaign })
      .then(({ data, status }) => {
        if (status === 200) {
          dispatch(setCampaignData(data.result))
        }
      })
      .catch(({ response = {}, message }) => {
        const { data } = response
        console.error('Add campaign error', data || message)
        throw data || message
      })
  }
}

export const launchCampaign = () => (dispatch, oldState) => {
  const {
    marketing: { campaign },
  } = oldState()

  return marketing
    .launchCampaign({ id: campaign._id, launchDate: campaign.launchDate })
    .then(({ data, status }) => {
      if (status === 200) {
        // dispatch(setCampaignData(data))
        dispatch(setCampaignData(emptyCampaign))
      }
    })
    .catch(({ response = {}, message }) => {
      const { data } = response
      console.error('Launch campaign error', data || message)
      throw data || message
    })
}

// TODO: delete campaign

// get filters
export const getFilters = () => (dispatch, oldState) => {
  const { brands, delegations } = oldState()

  const brandOptions = Object.values(brands).map((brand) => ({
    value: brand._id,
    label: brand.name,
  }))

  const delegationOptions = Object.values(delegations).map((delegation) => ({
    value: delegation._id,
    label: delegation.name,
  }))

  return marketing
    .getFilters()
    .then(({ data, status }) => {
      if (status === 200) {
        const filters = {
          ...data.results,
          brands: brandOptions,
          delegations: delegationOptions,
        }
        return filters
      }
    })
    .catch(({ response = {}, message }) => {
      const { data } = response
      console.error('Get filters error', data || message)
      throw data || message
    })
}

// Filter tickets
export const getTickets = (filterTickets = null) => (dispatch, oldState) => {
  const { marketing: { campaign } } = oldState()

  let queryFilters = {}
  if (!filterTickets) {
    Object.keys(campaign.filterTickets).forEach((f) => {
      const aFilters = campaign.filterTickets[f]

      if (aFilters && aFilters.length > 0) {
        queryFilters[f] = aFilters.map((elem) => (elem.value ? elem.value : elem)).join()
      }
    })
    queryFilters.size = 10000
  } else {
    queryFilters = { ...filterTickets, size: 10000 }
  }

  // dispatch(setCampaignData({ ...campaign, typeFilterUsed: 'filterTickets' }))

  // Delete excludeTicketsId from query
  const queryToSend = { ...queryFilters }
  delete queryToSend.excludeTicketsId

  return marketing
    .getTickets(queryToSend)
    .then(({ data, status }) => {
      if (status === 200) {
        return data
      }
    })
    .catch(({ response = {}, message }) => {
      const { data } = response
      console.error('Get tickets error', data || message)
      throw data || message
    })
}

export const getAdvancedTickets = () => (dispatch, oldState) => {
  const { marketing: { campaign } } = oldState()

  // dispatch(setCampaignData({ ...campaign, typeFilterUsed: 'advancedFilters' }))

  const filtersAdvanced = { ...campaign.advancedFilters, size: 10000 }
  delete filtersAdvanced.excludeTicketsId

  return marketing
    .getAdvancedFilteredTickets(filtersAdvanced)
    .then(({ data, status }) => {
      if (status === 200) {
        return data
      }
    })
    .catch(({ response = {}, message }) => {
      const { data } = response
      console.error('Post tickets error', data || message)
      throw data || message
    })
}

export const addSelectedFilters = (filterType) => (dispatch, oldState) => {
  const { marketing: { campaign } } = oldState()

  if (!['filterTickets', 'advancedFilters'].includes(filterType)) {
    filterType = 'none'
  }

  dispatch(setCampaignData({ ...campaign, typeFilterUsed: filterType }))
}

/**
 * Get chat templates by channel
 * @param {object} filters
 * @param {string} filters.channel
 * @param {string} filters.provider
 * @param {string} [filters.token] Only required for Whatsapp
 * @param {string} [filters.channelId] Only required for Whatsapp, if available.
 *
 * @returns {Promise<{ templates: [object] }>}
 */
const getChatTemplatesByChannel = (params = {}) => async (dispatch) => {
  try {
    dispatch(getAllTemplatesRequestAct())

    const { data } = await marketing.getChatTemplates(params)

    dispatch(getAllTemplatesSuccessAct(data))

    return data
  } catch(error) {
    dispatch(getAllTemplatesSuccessAct({ templates: [] }))

    return { templates: [] }
  }
}

const getAllTemplates = (isChat, filters = {}) => (dispatch) => {
  const type = isChat ? 'CHAT' : 'CAMPAIGN'

  return new Promise((resolve, reject) => {
    dispatch(getAllTemplatesRequestAct())

    const query = { type, ...filters }

    marketing.getAllTemplates(query).then(({ data, status }) => {
      if (status === 200) {
        dispatch(getAllTemplatesSuccessAct(data))
        return resolve(data)
      }
      return reject(data)
    })
  })
}

const createTemplate = (template, isChat) => (dispatch) => {
  template.type = isChat ? 'CHAT' : 'CAMPAIGN'

  return new Promise((resolve, reject) => {
    dispatch(createTemplateRequestAct())
    marketing
      .postTemplate(template)
      .then(({ data, status }) => {
        if(data.error){
          return resolve(data)
        }
        if (status === 200) {
          if(data.template.channel.toLowerCase() === 'whatsapp' && data.template.provider.toLowerCase() === 'whatsapp')
            data.template.channel = `${data.template.channel}_${data.template.provider}`
          dispatch(createTemplateSuccessAct(data))
          return resolve(data)
        }
        return reject(data)
      })
      .catch((error) => (error.response ? reject(error.response.data) : reject(error)))
  })
}

const updateTemplate = (id, template, isChat) => (dispatch) => {
  template.type = isChat ? 'CHAT' : 'CAMPAIGN'

  return new Promise((resolve, reject) => {
    dispatch(updateTemplateRequestAct())
    marketing
      .updateTemplate(id, template)
      .then(({ data, status }) => {
        if(data.error){
          return resolve(data)
        }
        if (status === 200) {
          if(data.template.channel.toLowerCase() === 'whatsapp' && data.template.provider.toLowerCase() === 'whatsapp')
            data.template.channel = `${data.template.channel}_${data.template.provider}`
          dispatch(updateTemplateSuccessAct(data))
          return resolve(data)
        }
        return reject(data)
      })
      .catch((error) => (error.response ? reject(error.response.data) : reject(error)))
  })
}

const deleteTemplate = (id) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(deleteTemplateRequestAct())
    marketing
      .deleteTemplate(id)
      .then(({ data, status }) => {
        if (status === 200) {
          dispatch(deleteTemplateSuccessAct(data))
          return resolve(data)
        }
        return reject(data)
      })
      .catch((error) => (error.response ? reject(error.response.data) : reject(error)))
  })
}

const getTemplateVariables = () => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(getTemplateVariablesRequestAct())
    marketing
      .getTemplateVariables()
      .then(({ data, status }) => {
        if (status === 200) {
          dispatch(getTemplateVariablesSuccessAct(data))
          return resolve(data)
        }
        return reject(data)
      })
      .catch((error) => (error.response ? reject(error.response.data) : reject(error)))
  })
}

const postPublishTemplate = (template, isChat) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(publishTemplateRequestAct())

    marketing.postPublishTemplate(template)
      .then(({ data, status })=>{
        if (status === 200) {
          dispatch(publishTemplateSuccessAct(data))
          dispatch(getAllTemplates(isChat))
          return resolve(data)
        }
        return reject(data)
      })
      .catch((error) => (error.response ? reject(error.response.data) : reject(error)))
  })
}

export const getCampaigns = (searchFilters = {}) => (dispatch, getState) => {
  const { marketing: marketingData } = getState()

  const newFilters = { ...marketingData, ...searchFilters }
  const { limit, page, textToSearch, name, startDate, endDate, duration, cost, createdAt, isActive, states, channels, operators, sortByField, sortType } = newFilters

  const filterChannels = channels.map(el => el.value)
  const filterOperators = operators.map(el => el.value)
  const filterStates = states.map(el => el.value)

  const queryFilters = {
    limit,
    page,
    textToSearch,
    name,
    startDate: TimeAndDate.betweenEndStartDayUTC(startDate[0], startDate[1]),
    endDate: TimeAndDate.betweenEndStartDayUTC(endDate[0], endDate[1]),
    createdAt: TimeAndDate.betweenEndStartDayUTC(createdAt[0], createdAt[1]),
    duration,
    cost,
    isActive,
    state: filterStates,
    channels: filterChannels,
    operators: filterOperators,
    sortByField,
    sortType,
  }
  return new Promise((resolve, reject) => {
    marketing
      .getCampaigns(queryFilters)
      .then(({ data, status }) => {
        if (status === 200) {
          dispatch(getCampaignsRequest(data))
          return resolve(data)
        }
        return reject(data)
      })
      .catch(({ response = {}, message }) => {
        const { data } = response
        return reject(data)
      })
  })
}

export const getCampaign = (id) => (dispatch) => {
  return new Promise((resolve, reject) => {
    marketing
      .getCampaign(id)
      .then(({ data, status }) => {
        if (status === 200) {
          dispatch(getCampaignRequest(data))
          return resolve(data)
        }
        return reject(data)
      })
      .catch(({ response = {}, message }) => {
        const { data } = response
        return reject(data)
      })
  })
}

export const setColsToShow = (value, position, reset) => (dispatch, getState) => {
  const { colsToShow } = getState().marketing
  if (!reset) {
    const indexCols = colsToShow.indexOf(value)
    if (indexCols === -1) {
      colsToShow.splice(position, 0, value)
    } else {
      colsToShow.splice(indexCols, 1)
    }
    dispatch(campaignsUpdateFilters(colsToShow))
  }
  else {
    getState().marketing.colsToShow = value
    dispatch(campaignsUpdateFilters(value))
  }
}

export const campaignsUpdateSearchText = (field, value) => (dispatch) => {
  dispatch({ field, value, type: types.MARKETING_CAMPAIGNS_UPDATE_FILTERS })
  callBounce(dispatch)
}

export const campaignsUpdateFilters = (field, value, refreshCampaigns = true) => (dispatch) => {
  dispatch({ field, value, type: types.MARKETING_CAMPAIGNS_UPDATE_FILTERS })
  refreshCampaigns && dispatch(getCampaigns({ [field]: value }))
}

export const notifySale = (id, body) => (dispatch) => {
  return marketing
    .notifySale(id, body)
    .then(({ data, status }) => {
      // if (status === 200) {}
      return true
    })
    .catch(({ response = {}, message }) => {
      const { data } = response
      console.error('Notify sale error', data || message)
      throw data || message
    })
}

export default {
  getAllTemplates,
  getChatTemplatesByChannel,
  createTemplate,
  updateTemplate,
  deleteTemplate,
  getTemplateVariables,
  getCampaigns,
  setColsToShow,
  campaignsUpdateSearchText,
  campaignsUpdateFilters,
  getCampaign,
  notifySale,
  postPublishTemplate
}
